export default {
	text: ['email','password','url','date','time','tel','search','number','hidden','month','datetime-local'],
}